.markdown-text {
  & > :first-child {
    margin-block-start: 0;
  }
  & > :last-child {
    margin-block-end: 0;
  }
  ol,
  li {
    p {
      margin: 0;
    }
  }
}
